import { useState, useEffect, useContext } from 'react'
import ContextStates from '../context/ContextStates'


const SearchAutoCompCli = (props) => {
    const [busqueda, setBusqueda] = useState([])
    const [pos, setPos] = useState(0)
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);
    const { idCliente, setIdCliente, searchCliente, setSearchCliente } = useContext(ContextStates)

    useEffect(() => {
        if (idCliente===0 && searchCliente==='') {
            /*console.log("termina aqui")
            setSearchCliente('')
            setBusqueda([])*/
            setPos(0)
            setIsDropdownVisible(false)
        }
    }, [idCliente])

    const filter = (item) => {
        let bus = item.target.value
        setSearchCliente(item.target.value)
        if (props.items) {
            if (item.target.value !== '') {
                let rData = []
                props.items.forEach(element => {
                    const palabrasCadena = element.label.toLowerCase().split(/\s+/);
                    const palabras = bus.toLowerCase().split(/\s+/);
                    if (palabras.every(palabraBuscada => {
                        const encontrado = palabrasCadena.some(palabraCadena => {
                            if (palabraCadena.includes(palabraBuscada)) {
                                return true;
                            }
                            return false;
                        });
                        return encontrado;
                    })) {
                        rData.push(element)
                    }
                });
                if (rData.length>0){

                }
                else {
                    setIdCliente(0)
                }

                setBusqueda(rData)
            }
            else {
                setBusqueda([])
                setIdCliente(0)
            }
        }
    }

    const handleItemSelect = (item) => {
        setSearchCliente(item.label);
        setIdCliente(item.id)
        setIsDropdownVisible(false);
    };

    const handleKeyDown = (event) => {
        //console.log("cantidad ",props.items.length)
        let posAct = pos;
        setIsDropdownVisible(true);
        if (event.key === 'ArrowDown') {
            if (posAct < busqueda.length - 1) {
                posAct++;
                setPos(posAct)
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'ArrowUp') {
            if (posAct > 0) {
                posAct--;
                setPos(posAct)
                setHighlightedIndex(posAct)
            }
        } else if (event.key === 'Enter') {
            if (highlightedIndex >= 0 && highlightedIndex < busqueda.length) {
                
                handleItemSelect(busqueda[highlightedIndex]);
            }
        }
    };

    return (
        <div className="w-full">
            <label htmlFor="descripcion" className="block text-gray-600 uppercase font-bold">Nombre o Dirección</label>
            <input
                type='text'
                className="py-2 px-3 w-full rounded border border-blue-300"
                value={searchCliente}
                onChange={filter}
                onKeyDown={handleKeyDown}
            />
            {isDropdownVisible && busqueda.length > 0 && (
                <ul
                    className='absolute mt-0 border border-gray-200 rounded-b-xl shadow-xl px-2 bg-white z-10'
                >
                    {busqueda.map((item, index) => (
                        <li
                            key={index}
                            onClick={() => handleItemSelect(item)}
                            className={`p-2 cursor-pointer ${highlightedIndex === index ? 'bg-blue-200' : 'bg-white'}`}
                        >
                            {item.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    )
}

export default SearchAutoCompCli